import { MainRecommendations } from "./recommendation";

const Request = () => <MainRecommendations title="Request" />;

export default Request;
